<template>
<div class="col q-mini-drawer-hide">
  <q-list sparator class="tree tree--project tree--full-height">
    <expansion-item
        expand-icon-toggle
        class="tree__item tree_item--active"
        default-opened
    >
      <template v-slot:header>
        <div class="heading-4 cursor-pointer" @click="$goto('project.show', {project_id: project.id})">
          {{ projectTitle }}
        </div>
      </template>
      <q-list separator class="tree">
        <item-link v-for="object in objects.data" :key="object.id"
                   :href="$route('project.object.show', {project_id: project.id, object_id: object.id})"
        >
          {{ object.title }} (<em>{{ object.type }}</em>)
        </item-link>
        <q-item v-if="objects.last_page > 1" class="flex flex-center">
          <pagination-links :items="objects" />
        </q-item>
      </q-list>
    </expansion-item>
  </q-list>
</div>
</template>

<script>
import { phaseStatusMixin } from "~HIOR/mixins"

export default {
  mixins: [phaseStatusMixin],
  props: {
    project: {
      type: Object,
    },
    projectTitle: {
      type: String,
    },
    objects: {
      type: Object,
      default: () => ({}),
    },
    expandable: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
